import { render, staticRenderFns } from "./CompanySuitcase.vue?vue&type=template&id=719a6dc2"
import script from "./CompanySuitcase.vue?vue&type=script&lang=js"
export * from "./CompanySuitcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports